function formatTimePart(timePart) {
    let [hour, minute] = timePart.split(":");
    hour = hour.padStart(2, '0');
    minute = minute.padStart(2, '0');
    return `${hour}:${minute}`;
}

function formatExcelTimeString(str) {
    let parts = str.split("~");

    if (parts.length !== 2) {
        throw new Error("Invalid time string format");
    }

    // 각 시간 부분을 HH:MM 형식으로 변환
    let formattedStart = formatTimePart(parts[0]);
    let formattedEnd = formatTimePart(parts[1]);

    return `${formattedStart}~${formattedEnd}`;
}

export default formatExcelTimeString;
